<template>
  <div class="wrapp">
    <modal-edit-demand :demand="this.editDemand" />
    <modal-edit-vehicle :vehicle="this.editVehicle" />
    <div class="row">
      <div class="col-12">
        <h2>Estoque Oferta/Procura</h2>
        <b-alert show variant="info" class="explain">
          Caso não encontrar o veículo desejado, clique na guia Procura e
            em Inserir novo veículo e faça sua solicitação
        </b-alert>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <b-tabs content-class="" v-model="showDemand">
          <div class="row mt-3 mb-3">
            <div class="row col-12">
              <form class="col-4 form-inline">
                <div class="">
                  <b-form-input
                  v-model="filter"
                  @keyup="search"
                  placeholder="Buscar ...">
                  </b-form-input>
                  <button class="btn btn-primary mb-2" @click="resetSearch">Limpar</button>
                </div>
              </form>
              <!--
              <div v-if="!showDemand" class="col-5 form-inline">
                <stockFilters/>
              </div>
              -->
              <form v-if="showDemand" class="col-8 f-right text-right form-inline">
                <div v-if="showDemand === 1" class="col-12 f-right">
                  <b-button
                    @click="$bvModal.show('modaldemand')"
                    class="btn btn-default mb-2 btn-secondary"
                    id="bt-procura"
                  >
                    Inserir Novo Veículo
                  </b-button>
                </div>
                <div v-else class="col-12 f-right">
                  <b-button
                    @click="$bvModal.show('modalvehicle')"
                    class="btn btn-default mb-2 btn-secondary"
                    id="bt-vehicle"
                  >
                    Inserir Veículo Programado
                  </b-button>
                </div>
              </form>
            </div>
          </div>
          <b-tab title="Oferta" active class="tabscroll">
            <offer/>
          </b-tab>
          <b-tab title="Procura" class="tabscroll">
            <demand :items="demands"/>
          </b-tab>
          <b-tab title="Veículos Programados" class="tabscroll">
            <vehicle :items="vehicleItems"/>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapFields } from 'vuex-map-fields';
import { mapActions, mapState } from 'vuex';
import offer from '../../../organisms/offer/index.vue';
import demand from '../../../organisms/demand/index.vue';
import vehicle from '../../../organisms/vehicle/index.vue';
// import stockFilters from '../../../organisms/stock-filter/index.vue';
import ModalEditDemand from '../../../organisms/modal-edit-demand/index.vue';
import ModalEditVehicle from '../../../organisms/modal-edit-vehicle/index.vue';
import EventBus from '../../../../eventBus';

const url = 'https://api.bi-assobens.com.br/v1';
// const url = 'http://localhost:3000/v1';

export default {
  name: 'OfertaProcura',
  components: {
    offer,
    demand,
    vehicle,
    // stockFilters,
    ModalEditDemand,
    ModalEditVehicle,
  },
  data: () => ({
    filter: null,
    offer: [],
    demand: [],
    vehicleItems: [],
    typingTimer: null,
    doneTypingInterval: 500,
    aop: [],
    region: [],
    editDemand: {},
    editVehicle: {},
    showDemand: 0,
    selectedAop: 'Todas',
    selectedRegion: 'Todas',
  }),
  watch: {
    tabIndex: function watchTabIndex() {
      this.showSupply = (this.tabIndex === 0);
    },
  },
  computed: {
    // ...mapState('stockOffer', ['offers', 'totalOffer']),
    ...mapState('stockDemand', ['demands', 'totalDemand']),
    ...mapFields('stockOffer', ['offers', 'totalOffer']),
  },
  methods: {
    ...mapActions('stockOffer', ['getStockOffer']),
    ...mapActions('stockDemand', ['getStockDemand', 'createStockDemand']),

    async loadStockData() {
      await Promise.all([
        this.getStockDemand({
          filter: this.filter,
        }),
        this.getStockOffer({
          filter: this.filter,
          segmentos: this.userAuth.segmentos,
        }),
        this.getVehiclesData({
          filter: this.filter,
        }),
      ]);
      this.items = this.offers;
    },
    search() {
      this.items = [];
      if (
        this.filter !== ''
        && this.filter !== null
        && this.filter.length > 2
      ) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(
          this.loadStockData,
          this.doneTypingInterval,
        );
      } else {
        this.items = [];
        this.loadStockData();
      }
    },
    resetSearch() {
      this.filter = null;
      this.loadStockData();
    },
    async getVehiclesData() {
      try {
        const { data } = await axios.get(`${url}/vehicles`, {
          params: {
            filter: this.filter ? this.filter : null,
          },
        });
        this.vehicleItems = data.vehicles;
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async createVehicle(obj) {
      try {
        await axios.post(
          `${url}/vehicles`,
          { ...obj.data },
          { headers: { 'x-access-token': obj.data.token } },
        );
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
  },
  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_pbiAssobens'));
    await this.loadStockData();
  },
  async mounted() {
    EventBus.$on('saveDemandInfo', async (demandEdited) => {
      // eslint-disable-next-line prefer-const
      let demandToSend = demandEdited;
      demandToSend.token = this.userAuth.token;
      demandToSend.user_id = this.userAuth.id;
      try {
        await this.createStockDemand({
          data: { ...demandToSend },
        });
        this.$swal(
          'Sucesso!',
          'As informações do veículo foram salvas.',
          'success',
        );
        await this.getStockDemand({
          filter: this.filter,
        });
        this.items = this.demands;
        this.demand = this.items;
      } catch (error) {
        this.$swal('Falhou!', 'error');
      }
    });
    EventBus.$on('refresh-demands', () => {
      this.getStockDemand({
        filter: this.filter,
      }).then(() => {
        this.items = this.demands;
        this.demand = this.items;
      });
    });
    EventBus.$on('refresh-vehicles', () => {
      this.getVehiclesData({
        filter: this.filter,
      }).then(() => {
        this.items = this.vehicles;
      });
    });
    EventBus.$on('saveVehicleInfo', async (vehicleEdited) => {
      // eslint-disable-next-line prefer-const
      let vehicleToSend = vehicleEdited;
      vehicleToSend.token = this.userAuth.token;
      vehicleToSend.user_id = this.userAuth.id;
      try {
        await this.createVehicle({
          data: { ...vehicleToSend },
        });
        this.$swal(
          'Sucesso!',
          'As informações do veículo foram salvas.',
          'success',
        );
        await this.getVehiclesData({
          filter: this.filter,
        });
        this.items = this.vehicleItems;
      } catch (error) {
        this.$swal('Falhou!', 'error');
      }
    });
    // EventBus.$on('change-aop', (newValue) => {
    //   this.selectedAop = newValue;
    //   this.loadData();
    // });
    // EventBus.$on('change-region', (newValue) => {
    //   this.selectedRegion = newValue;
    //   this.loadData();
    // });
    this.selectedAop = 'Todas';
    this.selectedRegion = 'Todas';
  },
};
</script>

<style lang="scss" scoped>
.wrapp {
  padding: 16px;
  max-height: calc(100vh - 72px);
  background-color: #f1f1f1;
  overflow: auto;
}
.f-right {
  float: right;
}
.explain {
  background-color: transparent;
  border: none;
  color: #212529;
}
.btn-primary {
  background-color: #694cfe !important;
  border-color: #694cfe !important;
  margin-left: 10px;
  margin-top: 5px;
}
</style>
<style>
th {
    background-color: #70ad47;
    color: #fff;
}
#bt-procura, #bt-vehicle   {
    background-color: #5b9bd5 !important;
    border-color: #5b9bd5 !important;
}
.nav-tabs {
    border-bottom: 1px solid #ccc !important;
}
.tabscroll {
  overflow: auto;
}
.maxcontent {
  overflow: auto;
  width: max-content;
}
</style>
